import React from "react";
import { motion } from "../components/StaticMotion";
import { HoverCard, HoverIcon } from "../components/HoverMotion";

const cardVariants = {
  hidden: { opacity: 0, y: 25, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
};

export const SectionOurClients = () => {
  const testimonials = [
    {
      id: 1,
      quote: "VIONIXASIA's registration and timing systems transformed how we manage our annual trail race. The data accuracy and participant experience were night and day compared to our previous setup.",
      name: "Vero Budiman",
      role: "Operations Manager",
    },
    {
      id: 2,
      quote: "Having live GPS tracking and real-time results running simultaneously gave our spectators and families something to rally around. The platform is genuinely impressive.",
      name: "Elira Lirisya",
      role: "Event Director",
    },
    {
      id: 3,
      quote: "Working with the VIONIXASIA team was seamless from day one. Their systems are intuitive, their support is responsive, and the overall event experience improved dramatically.",
      name: "Denis Saputra",
      role: "Event Coordinator",
    },
  ];

  return (
    <section id="testimonials" className="w-full py-16 lg:py-24 px-4 bg-slate-50 overflow-hidden">
      <motion.div
        className="w-full max-w-6xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center mb-10">
          <motion.h2
            className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Client Testimonials
          </motion.h2>
          <motion.p
            className="text-gray-600 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            Hear directly from the organizers who have relied on VIONIXASIA to power their events — and the impact our platforms made on their operations.
          </motion.p>
        </div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
          variants={{ visible: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } } }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {testimonials.map((t, index) => (
            <motion.div
              key={t.id}
              variants={cardVariants}
              className={index !== 1 ? "lg:pt-12" : ""}
            >
              <HoverCard className={`p-4 h-full flex flex-col gap-4 rounded-card border border-slate-200 ${index === 1 ? "bg-slate-900" : "bg-white"}`}>
                <HoverIcon className={`w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-icon border ${index === 1 ? "bg-white/10 border-white/20" : "bg-slate-100 border-slate-200"}`}>
                  <svg className={`w-5 h-5 ${index === 1 ? "text-white" : "text-slate-500"}`} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
                  </svg>
                </HoverIcon>

                <p className={`text-sm leading-relaxed flex-1 ${index === 1 ? "text-slate-300" : "text-slate-600"}`}>
                  {t.quote}
                </p>

                <div className={`flex items-center gap-3 pt-3 border-t ${index === 1 ? "border-white/10" : "border-slate-200"}`}>
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center text-xs font-bold border ${index === 1 ? "bg-white/10 text-white border-white/20" : "bg-slate-100 text-slate-700 border-slate-200"}`}>
                    {t.name.split(" ").map((n) => n[0]).join("")}
                  </div>
                  <div>
                    <p className={`text-sm font-bold leading-tight ${index === 1 ? "text-white" : "text-slate-900"}`}>
                      {t.name}
                    </p>
                    <p className="text-xs text-white font-medium">
                      {t.role}
                    </p>
                  </div>
                </div>
              </HoverCard>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};
